import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=36f20000&scoped=true&"
import script from "./Achievements.vue?vue&type=script&lang=js&"
export * from "./Achievements.vue?vue&type=script&lang=js&"
import style0 from "./Achievements.vue?vue&type=style&index=0&id=36f20000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f20000",
  null
  
)

export default component.exports